import React from 'react'

import { ConfirmModal, useModalContext } from '@fourthwall/components'

import * as S from './styled'

type ProductSlugUpdateModalProps = {
  baseUrl: string
  newSlug: string
  prevSlug: string
  onConfirm: () => void
  onCancel?: () => void
}

export const ProductSlugUpdateModal = ({
  baseUrl,
  newSlug,
  prevSlug,
  onConfirm,
  onCancel,
}: ProductSlugUpdateModalProps) => {
  const { close } = useModalContext()

  return (
    <ConfirmModal
      size="medium"
      maxWidth={700}
      title="Update URL to match new product name?"
      text="Do you want to update the URL of your product to match your new product name? The new URL would be:"
      additionalContent={
        <>
          <S.LinkContainer>
            {baseUrl}
            <S.SlugContainer>{newSlug}</S.SlugContainer>
          </S.LinkContainer>
          <S.InfoContainer>
            Your current URL is {baseUrl}
            <S.SlugContainer>{prevSlug}</S.SlugContainer>
          </S.InfoContainer>
        </>
      }
      confirmLabel="Update URL"
      cancelLabel="Keep current URL"
      close={close}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}
